var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcMail = function SvgIcMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C606B",
    fillRule: "evenodd",
    d: "M2.51 5.769A2.53 2.53 0 0 0 2.5 6v7.667a2.5 2.5 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5V6c0-.078-.004-.155-.01-.231a.499.499 0 0 0-.06-.357A2.501 2.501 0 0 0 16 3.5H5a2.501 2.501 0 0 0-2.43 1.912.498.498 0 0 0-.06.357Zm.99.832v7.066a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5V6.6l-6.723 4.482a.5.5 0 0 1-.554 0L3.5 6.6Zm13.902-1.136A1.5 1.5 0 0 0 16 4.5H5a1.5 1.5 0 0 0-1.402.965l6.902 4.6 6.902-4.6Z",
    clipRule: "evenodd"
  })));
};
export default SvgIcMail;